import React, { forwardRef, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { c as classnames } from './index-2586sEvh.js';
import { S as Sizes } from './Sizes-tn0Bbk4S.js';

const SizeField = forwardRef(({ option, register, errors, onChartOpen, textSizeGuideButton, onOptionsChange }, ref) => {
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    useEffect(() => {
        if (typeof onOptionsChange === 'function')
            onOptionsChange(option.option.attribute_code);
    }, [option.option.values.length]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "col-left" },
            React.createElement("div", { className: "product-sizes" },
                React.createElement(Sizes, { option: option.option, disabled: option.disabled, register: register, errors: errors }))),
        option.variantInfoContent && (React.createElement("div", { className: "col-right col-right-variant-info" },
            React.createElement("button", { ref: ref, type: "button", className: classnames('info-variant-btn', {
                    'info-variant-btn-text': textSizeGuideButton,
                }), "aria-label": "Show attribute info", onClick: onChartOpen },
                React.createElement("i", { className: "icon-faq" }),
                textSizeGuideButton && React.createElement("span", null, tLabel('beddingSizeGuide')))))));
});
SizeField.displayName = 'SizeField';

export { SizeField as S };
//# sourceMappingURL=SizeField-JNtoYwfb.js.map
